import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AppService } from './app.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(private router: Router, private appService: AppService) { }

  canActivate(next: ActivatedRouteSnapshot) {
    if (sessionStorage.examineeUser && next.routeConfig.path.includes('delivery')) { return true; }

    if (sessionStorage.currentUser) {
      this.appService.changeUserHeader(1);
      return true;
      // return this.roleSer.accessData && this.roleSer.navigationRole[this.roleSer.accessData.featureName];
    }

    this.router.navigate(['/login'], {
      queryParams: { returnUrl: next['_routerState'].url },
    });
    return false;
  }
}
